import { render, staticRenderFns } from "./AdminContent.vue?vue&type=template&id=0542f6dd&scoped=true&"
import script from "./AdminContent.vue?vue&type=script&lang=js&"
export * from "./AdminContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0542f6dd",
  null
  
)

export default component.exports